import React, { useEffect, useState } from "react";
import NavBar from "../components/Navigation/NavBar";
import { displayDateTime, getConfig, getConfigV1, getConstant, handleHeader } from "../services/functions";
import { BASE_URL } from "../utility/path";
import { getNotificationStyle } from "../utility/colorUtils";
import axios from "axios";
import MainContainer from "../components/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import "../notification.css";
import BottomNav from "../components/Navigation/BottomNav";


const NotificationItem = ({ notification }) => {
  const style = getNotificationStyle(notification?.type);
  const isRead = notification?.read;

  return (
    <li
      className={`nf-item ${isRead ? "nf-item--read" : "nf-item--unread"}`}
      style={!isRead && style.accent
        ? { borderLeftColor: style.accent }
        : {}
      }
    >
      {/* Icon */}
      <div
        className="nf-icon"
        style={{ background: style.gradient || "#e5e7eb" }}
      >
        <i className={`fa ${style.icon}`} />
      </div>

      {/* Content */}
      <div className="nf-content">
        <div className="nf-content__top">
          <p className="nf-title">{notification.title}</p>
          {isRead
            ? <i className="fa fa-check-circle" style={{ color: "#3b82f6", fontSize: 14 }} />
            : <span className="nf-dot" style={{ background: style.accent }} />
          }
        </div>
        <p className="nf-message">{notification.message}</p>
        <span className="nf-time">
          <i className="fa fa-clock-o" /> {displayDateTime(notification.createdAt)}
        </span>
      </div>
    </li>
  );
};

const Notification = () => {
  const [state, setState] = useState([]);
  const dispatch = useDispatch();
  const authData = useSelector((state) => state?.auth?.data);

  useEffect(() => {
    handleHeader({ ...getConstant("NOTIFICATIONS") }, dispatch);
    loadData();
  }, []);

  const markAllRead = () => {
    const updated = state.map((n) => ({ ...n, read: true }));
    setState(updated);
    localStorage.setItem("notification", JSON.stringify(updated));
  };

  const loadData = async () => {
    try {
      const config = getConfigV1("", authData);
      const res = await axios.get(`${BASE_URL}/api/notification/g/list`, config);
      if (res?.data) {
        // Preserve read status from localStorage across reloads
        const saved = JSON.parse(localStorage.getItem("notification") || "[]");
        const readIds = new Set(saved.filter((n) => n.read).map((n) => n._id || n.id));

        const merged = res.data.map((n) => ({
          ...n,
          read: readIds.has(n._id || n.id), // restore read state
        }));

        localStorage.setItem("notification", JSON.stringify(merged));
        setState(merged);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  const unreadCount = state.filter((n) => !n.read).length;

  return (
    <>
      <NavBar />
      <MainContainer>
        <div className="nf-page">

          {/* Header */}
          <div className="nf-header">
            <div>
              <h3 className="nf-header__title">Notifications</h3>
              {unreadCount > 0 && (
                <p className="nf-header__count">{unreadCount} unread</p>
              )}
            </div>
            {unreadCount > 0 && (
              <span className="nf-mark-read" onClick={markAllRead}>
                Mark all read
              </span>
            )}
          </div>

          {/* List */}
          <ul className="nf-list">
            {state.length > 0 ? (
              state.map((notification) => (
                <NotificationItem
                  key={notification._id || notification.id}
                  notification={notification}
                />
              ))
            ) : (
              <div className="nf-empty">
                <i className="fa fa-bell-slash nf-empty__icon" />
                <p>No notifications yet</p>
              </div>
            )}
          </ul>

        </div>
      </MainContainer>
      <BottomNav/>
    </>
  );
};

export default Notification;

